export default {
    props: {
        label: {
            type: String,
            required: false,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        labelComputed: function () {
            if (this.label === '') {
                return;
            }

            let text = this.label !== null ? this.uLang('app.' + this.label) : this.uLang('app.' + this.name);
            return text + (this.required ? ': *' : ': ');
        },
    }
}